// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: '#000000, #090909, #131313, #1A1A1A, #202020',
  firstName: 'Bharat',
  middleName: '',
  lastName: 'Sharma',
  message:
    '  Software Engineer ⚛ (Full Stack Developer) ⚛ Technology Enthusiast',
  icons: [
    {
      image: 'fa-github',
      url: 'https://github.com/bharat2913',
    },
    {
      image: 'fa-upwork',
      url: 'https://www.upwork.com/freelancers/~0191ee67fea880bf07',
    },
    // {
    //   image: 'fa-instagram',
    //   url: 'https://www.instagram.com/bharat.sharma._/',
    // },
    {
      image: 'fa-linkedin',
      url: 'https://www.linkedin.com/in/bharatsharma-549991/',
    },
  ],
};

const about = {
  show: true,
  heading: 'About Me',
  imageLink: require('./bharat.jpg'),
  imageSize: 375,
  message: (
    <p>
      Hello! I'm <strong>Bharat</strong>, a{' '}
      <strong>Full Stack Developer</strong>. <br />
      <strong>
        <a
          href='https://www.upwork.com/freelancers/~0191ee67fea880bf07'
          target={'_blank'}
          rel='noreferrer'
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          Top-Rated Freelancer on Upwork
        </a>
      </strong>
      with strong design skills and expertise in <b>React/Typescript</b>. I hold
      a background in formal education, and my passion for coding is
      complemented by hobbies like exploring new technologies and building
      innovative web applications.
    </p>
  ),
  resume: require('./BharatSharmaResume.pdf'),
};

const repos = {
  show: true,
  heading: 'Recent Projects',
  gitHubUsername: 'bharat2913',
  reposLength: 25,
  specificRepos: [],
  projects: [
    {
      name: 'Esplanda',
      description:
        'E-Commerce store for Restaurants, Liquor Stores, and Grocery Stores. ',
      github_url: '',
      technologies: [
        'ReactJS',
        'Javascript',
        'GrapeJs',
        'SCSS',
        'Redux',
        'Stripe',
      ],
      live_link: 'https://esplanda.com/',
    },
    {
      name: 'MyKidReports',
      description:
        'MyKidReports offers a comprehensive Childcare Management Solution that simplifies the administration of your center',
      github_url: '',
      technologies: ['NextJS', 'Javascript', 'SCSS', 'Redux', 'Stripe'],
      live_link: 'https://mykidreports.com/',
    },
    {
      name: 'bswebsitedesign',
      description: 'Landing page for Web design Agency',
      github_url: '',
      technologies: ['React Js', 'Typescript', 'SCSS', 'Framer Motion'],
      live_link: 'https://bswebsitedesign.netlify.app/',
    },
    {
      name: 'Car Renting SaaS Platform',
      description:
        'A SaaS platform with admin and customer panel where user can rent car and many features. ',
      technologies: [
        'React',
        'Javascript',
        'CSS',
        'Redux',
        'Node',
        'Stripe',
        'Twillo',
        'Send Grid',
        'Google Calendar API',
      ],
      live_link: 'https://company1.aviosoftware.com/',
      github_url: '',
    },
    {
      name: 'CV-Jury',
      description: 'Resume builder application',
      technologies: [
        'React',
        'Javascript',
        'SCSS',
        'Node',
        'Stripe',
        'WYSIWYG Editor',
      ],
      live_link: 'https://cvjury-main.vercel.app/',
      github_url: '',
    },
    {
      name: 'AyushaOpus',
      description: 'Metal Art and Design',
      technologies: ['React', 'Javascript', 'Styled Components', 'GSAP'],
      live_link: 'https://ayushaopus.com/',
      github_url: '',
    },
    // {
    //   name: 'Personal Project',
    //   description: 'Instagram Clone',
    //   technologies: ['React', 'Javascript', 'Tailwind', 'Firebase'],
    //   live_link: 'https://metagramm.netlify.app/',
    //   github_url: 'https://github.com/bharat2913/metagram',
    // },
    // {
    //   name: 'Personal Project',
    //   description: 'Netflix Clone',
    //   technologies: ['React', 'Javascript', 'Styled Components', 'Firebase'],
    //   live_link: 'https://net-star.netlify.app/',
    //   github_url: 'https://github.com/bharat2913/netflix-clone',
    // },
    // {
    //   name: 'Personal Project',
    //   description: 'Movie Finder',
    //   technologies: ['React', 'Javascript', 'CSS', 'TMDB API'],
    //   live_link: 'https://moviefinderr.netlify.app/',
    //   github_url: 'https://github.com/bharat2913/movies-app',
    // },
  ],
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: 'Skills',
  hardSkills: [
    { name: 'ReactJS', value: 90 },
    { name: 'Node', value: 80 },
    { name: 'Firebase', value: 70 },
    { name: 'Laravel', value: 90 },
    { name: 'MongoDB', value: 90 },
    { name: 'Data Structures', value: 70 },
    { name: 'Next Js', value: 90 },
    { name: 'JavaScript', value: 90 },
    { name: 'Tailwind CSS', value: 90 },
    { name: 'Git/GitHub', value: 90 },
    { name: 'SQL', value: 90 },
    { name: 'Deployment', value: 70 },
  ],
  softSkills: [
    { name: 'Goal-Oriented', value: 80 },
    { name: 'Collaboration', value: 90 },
    { name: 'Positivity', value: 75 },
    { name: 'Adaptability', value: 85 },
    { name: 'Problem Solving', value: 75 },
    { name: 'Empathy', value: 90 },
    { name: 'Organization', value: 70 },
    { name: 'Creativity', value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: 'Get In Touch',
  message:
    'If you know of any positions available, have any questions, or just want to say hi, please feel free to email me at',
  email: 'shbharat5419@gmail.com',
};

const experiences = {
  show: false,
  heading: 'Experiences',
  data: [
    {
      role: 'Mid Level Software Engineer (JVM)', // Here Add Company Name
      companylogo: require('../assets/img/Zalando-SE-logo.png'),
      date: 'Sep 2022 – Present',
    },
    {
      role: 'Software Engineer (Python/Django)', // Here Add Company Name
      companylogo: require('../assets/img/cynopsis.png'),
      date: 'Oct 2021 – Present',
    },
    {
      role: 'Software Engineer (Java)', // Here Add Company Name
      companylogo: require('../assets/img/dhl.jpg'),
      date: 'Oct 2021 – May 2022',
    },
    {
      role: 'Software Engineer (Back-end/Data Analytics)',
      companylogo: require('../assets/img/rubikal.png'),
      date: 'Jan 2021 – Jun 2022',
    },
    {
      role: 'Cloud Native Engineer (Part time)', // Here Add Company Name
      companylogo: require('../assets/img/cassbana.png'),
      date: 'Oct 2020 – Feb 2021',
    },
    {
      role: 'Software Engineer (Full-stack)',
      companylogo: require('../assets/img/sia.jfif'),
      date: 'Apr 2020 – Dec 2020',
    },
    {
      role: 'Software Engineer (Undergraduate)',
      companylogo: require('../assets/img/robotech.png'),
      date: 'Aug 2018 – April 2020',
    },
  ],
};

export { navBar, mainBody, about, repos, skills, getInTouch, experiences };
